/**
 * JOProductViewTracker — Increments the daily view counter when a user
 * visits `/shop/:slug`. Throttled per session (sessionStorage) to avoid
 * inflating counts on refreshes.
 *
 * Renderless — runs once per route change.
 */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SESSION_PREFIX = "jdo_viewed_";

export default function JOProductViewTracker() {
  const location = useLocation();

  useEffect(() => {
    const match = location.pathname.match(/^\/shop\/([^/?#]+)/);
    if (!match) return;
    const slug = match[1];
    const key = SESSION_PREFIX + slug;
    try {
      if (sessionStorage.getItem(key)) return;
      // Tiny delay so the user actually loaded the page (filters bounce)
      const timeout = setTimeout(() => {
        axios.post(`${API}/jardins-ole/shop/views/${encodeURIComponent(slug)}`)
          .then(() => { try { sessionStorage.setItem(key, "1"); } catch {} })
          .catch(() => {});
      }, 2500);
      return () => clearTimeout(timeout);
    } catch {
      /* sessionStorage may be unavailable */
    }
  }, [location.pathname]);

  return null;
}
